var _circle, _circle2, _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineAreaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0E5AA7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9998,
    cy: 16.0003,
    rx: 13.6585,
    ry: 13.6585,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.191 10.0746C13.5188 11.1138 12.7692 13.0244 12.6935 14.8735C12.6886 14.9788 12.6873 15.0833 12.6873 15.1879V15.1876C12.6873 15.1977 12.6855 15.2511 12.6855 15.2685V21.8364H14.8611V15.2685C14.8611 14.8539 15.0489 14.4836 15.3437 14.2381L16.2021 15.2685L17.0591 14.2383C17.354 14.4836 17.5423 14.8539 17.5423 15.2685V21.8364H19.7174V15.2685C19.7174 13.3267 18.1431 11.7525 16.2021 11.7525C15.7424 11.7525 15.3037 11.8403 14.9023 12.001V12.0006C15.3479 11.4774 16.0209 11.2181 16.7567 11.2022H16.7584C16.9881 11.1967 17.224 11.2159 17.4606 11.2578C19.3857 11.5732 20.8522 13.1866 20.8597 15.1325C20.8635 15.2067 20.8649 15.2818 20.8649 15.3581V21.8364H23.0413V15.3034C23.0413 12.4738 21.3408 10.2051 18.4425 9.52964C18.3368 9.50563 18.1691 9.47189 18.0191 9.45174C17.8048 9.42327 17.585 9.39941 17.358 9.39941C16.8871 9.39941 16.545 9.48289 16.1509 9.61415C15.87 9.7084 15.5917 9.82465 15.191 10.0746Z",
    fill: "#0E5AA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7845 9.36548C12.0053 9.36548 9.36572 11.8893 9.36572 15.2354V21.8533H11.5585C11.5585 21.8533 11.5567 18.2124 11.5567 15.2306C11.5567 12.1181 13.9393 9.8982 16.3304 9.41637C16.4277 9.39612 16.5418 9.36548 16.4282 9.36548H15.7845Z",
    fill: "#EE2527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineAreaIcon);
export default __webpack_public_path__ + "static/media/timeline-area-icon.2207c0eda72b8a4625429f74d743065bc47f52be60bb3359b08ec26c22afaef0.svg";
export { ForwardRef as ReactComponent };